export default __webpack_public_path__ + "static/media/Giulietta.5c6935e6.jpg";